import styled from '@emotion/styled';

export const Container = styled.div`
	background: #fff;
	overflow: auto;
	overflow-y: hidden;
	padding: 8px 0;
	white-space: nowrap;

	section {
		width: auto;
		display: inline-block;
		margin-right: 5px;
	}

	button {
		background: none;
		&:first-of-type {
			margin-left: auto;
		}
		&:last-of-type {
			margin-right: auto;
		}
	}

	@media ${({ theme }) => theme.medias.desktop} {
		display: flex;
	}

	${({ theme }) => theme && theme.mixins && theme.mixins.scrollBar}

	::-webkit-scrollbar {
		height: 8px;
	}
`;
